import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { Banner } from '@ingenico/react-ui/banner';
import { useTranslation } from 'react-i18next';

export function BlockedDeviceBanner({
  isBlocked,
  onUnblock: _onUnblock,
}: {
  readonly isBlocked: boolean;
  readonly onUnblock: () => void;
}) {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE, ALL_LNGS_NAMESPACES.PHYSICAL_DEVICE]);
  if (!isBlocked) {
    return null;
  }
  return (
    <Banner
      message={t('unblockDeviceModal.banner.message', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
      title={t('unblockDeviceModal.banner.title', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
      //FLAG
      // hasCustomButton
      // customButtonLabel={t('button.unblock', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
      // onCustomButtonClick={onUnblock}
    />
  );
}
